<template>
  <div class="select" v-click-outside="close">
    <div class="select__main"> 
      <div class="label m-description">
        {{ label }}
      </div>
      <div
        class="value"
        @click="toggleState"
      >
        <span class="value__text">
          {{ getItemName(selectedItem) }}
        </span>
        <m-icon
          :icon="icon"
          color="m-primary"
        />
      </div>
    </div>

    <div
      v-if="state"
      class="select__items"
    >
      <div
        class="select__item"
        v-for="(item, idx) in items"
        :key="`${idx}-item`"
        @click="onSelectItem(item)"
      > 
        <m-simple-checkbox
          v-if="multiple"
          :value="itemInArrayFlag(item)"
          @change="[closeOnClickCheckboxBugfix(), onSelectItem(item)]"
        />

        <div class="select__item_name">
          {{ getItemName(item) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
  name: 'm-select',
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedItem: {
      type: [Object, String, Number, Array],
      required: true,
    },
    label: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: false,
    }
  },
  computed: {
    icon() {
      return this.state ? 'expand_less' : 'expand_more'
    },
  },
  methods: {
    // TODO fix this bug when click on checkbox
    closeOnClickCheckboxBugfix() {
      setTimeout(() => {
        this.state = true
      }, 1);
    },
    toggleState() {
      this.state = !this.state;
    },
    getItemType(item) {
      if (Array.isArray(item)) {
        return 'array'
      }
      if (typeof item === 'object' && !Array.isArray(item)) {
        return 'object'
      }

      return 'string'
    },
    onSelectItem(item) {
      if (!this.multiple) {
        this.$emit('select', item)

        this.toggleState()
      } else {
        let newSelectedItems = [...this.selectedItem]
        const itemType = this.getItemType(item)
        const itemInArray = this.itemInArrayFlag(item)

        if (itemType === 'object') {
          if (itemInArray) {
            newSelectedItems = newSelectedItems.filter(el => el.value !== item.value)
          } else {
            newSelectedItems.push(item)
          }
        } else {
          if (itemInArray) {
            newSelectedItems = newSelectedItems.filter(el => el !== item)
          } else {
            newSelectedItems.push(item)
          }
        }

        this.$emit('select', newSelectedItems)
      }
    },
    itemInArrayFlag(item) {
      const itemType = this.getItemType(item)

      if (itemType === 'object') {
        return this.selectedItem.some(el => el.value === item.value)
      } else {
        return this.selectedItem.some(el => el === item)
      }
    },
    close() {
      this.state = false
    },
    getItemName(item) {
      const itemType = this.getItemType(item)
      if (itemType === 'array') {
        return item.join(', ')
      }
      if (itemType === 'object') {
        return item?.name || ''
      }

      return item
    },
  },
  directives: {
    ClickOutside
  }
}
</script>

<style lang="scss" scoped>
.select {
  position: relative;
  max-width: 500px;
  width: 100%;
  user-select: none;

  &__main {
    width: 100%;
    padding: 10px 0;
    z-index: 8;
    .label {
      margin-bottom: 0.25rem;
    }

    .value {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 94%;
      border: 1px solid $primary-old;
      border-radius: 0.25rem;
      color: $primary-old;
      cursor: pointer;
      padding: 0.375rem 0.75rem;
      line-height: 1.5;

      &__text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }

  &__items {
    position: absolute;
    display: flex;
    flex-direction: column;
    border: 1px solid $primary-old;
    background-color: $white;
    width: 94%;
    padding: 0.375rem 0.75rem;
    gap: 5px;
    z-index: 9;
  }

  &__item {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;

    &:hover {
      color: $primary-old;
    }
  }
}
</style>